import { createContext } from 'react';

const PersonalInfoContext = createContext();

export default PersonalInfoContext;